import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import {CoreModule} from '@Common/core/core.module';
import {CommonModuleP8} from '@Common/common-p8.module';
import {AppRoutingModule} from './app-routing';
import {HandlerError} from '@Common/handler-error';
import {FlexLayoutModule} from "@Common/widgets/flex-layout/flex-layout.module";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule, registerLocaleData} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAngularModule} from '@Common/mat-angular.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {AppComponent} from './app.component';
import {AccueilComponent} from './accueil/accueil.component';
import { ActivitiesComponent } from './activities/activities.component';
import { ActivityComponent } from './activities/activity/activity.component';
import { ActivityDetailComponent } from './activities/activity-detail/activity-detail.component';
import { MenuComponent } from './activities/menu/menu.component';
import { FilterPanComponent } from './activities/filter-pan/filter-pan.component';
import {PaginatorComponent} from "./activities/paginator/paginator.component";
import { AccessibilityComponent } from './activities/accessibility/accessibility.component';
import {NeoModule} from "@Common/neo-components/neo.module";
import { ThemeChoiceComponent } from './activities/theme-choice/theme-choice.component';

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

@NgModule({
  declarations: [
    AppComponent,
    AccueilComponent,
    ActivitiesComponent,
    ActivityComponent,
    ActivityDetailComponent,
    MenuComponent,
    PaginatorComponent,
    FilterPanComponent,
    AccessibilityComponent,
    ThemeChoiceComponent,
  ],
    imports: [
        BrowserAnimationsModule,
        CoreModule,
        CommonModuleP8,
        AppRoutingModule,
        FlexLayoutModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAngularModule,
        MatTreeModule,
        MatInputModule,
        MatFormFieldModule,
        NeoModule,
    ],

  providers: [
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    {provide: ErrorHandler, useClass: HandlerError},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
